/**
 * @generated SignedSource<<621769f91e46671822418ba36231caa8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateProjectInput = {
  customerAccountIdentifier: string;
  endsAt?: any | null | undefined;
  projectName: string;
  startsAt?: any | null | undefined;
};
export type CreateProjectDialogMutation$variables = {
  input: CreateProjectInput;
};
export type CreateProjectDialogMutation$data = {
  readonly createProject: {
    readonly customerAccountIdentifier: string;
    readonly id: string;
    readonly projectName: string;
  };
};
export type CreateProjectDialogMutation = {
  response: CreateProjectDialogMutation$data;
  variables: CreateProjectDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Project",
    "kind": "LinkedField",
    "name": "createProject",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerAccountIdentifier",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateProjectDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateProjectDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "77d69a6555a64eb1eafa9d577d4f8a02",
    "id": null,
    "metadata": {},
    "name": "CreateProjectDialogMutation",
    "operationKind": "mutation",
    "text": "mutation CreateProjectDialogMutation(\n  $input: CreateProjectInput!\n) {\n  createProject(input: $input) {\n    id\n    projectName\n    customerAccountIdentifier\n  }\n}\n"
  }
};
})();

(node as any).hash = "d89b03de008fd912ced3f197a0a7615d";

export default node;
